module.exports = __webpack_public_path__ + "static/media/octes8h_3.9efcdc45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/octes/octes8h_3.svg
// module id = 748
// module chunks = 0